import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../shared/LoadingSpinner';

export default function RequireAuth({ allowedRoles }) {
  const { isAuthenticated, loading, role } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-cream-100)]">
        <LoadingSpinner text="Checking session..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    // Redirect to their role home instead of showing an error
    const home = {
      super_admin: '/admin',
      bookkeeper: '/bookkeeper',
      auditor: '/auditor',
      store_user: '/store',
    }[role] || '/';
    return <Navigate to={home} replace />;
  }

  return <Outlet />;
}
